export default __webpack_public_path__ + "static/media/promocode_mobile_En.7a8c4b15.webp";